document.addEventListener("DOMContentLoaded", () => {
    const signupBtnHeader = document.querySelector("#signup-toggle-header");
    const signupBtnBody = document.querySelector("#signup-toggle-body");

    const signupCancel = document.querySelector(".btn-hide-form");
    const signupModal = document.querySelector("#signup-modal");
    const signupForm = document.querySelector("#signup-form");
    const createAccountBtn = document.querySelector(".step a[href=\"#step-1\"]");

    const toggleSignupForm = (show) => {
        signupBtnBody.style.display = show ? "none" : "inline-block";
        signupForm.classList.toggle("hide-signup", !show);
        signupForm.classList.toggle("show-signup", show);
    };

    if (createAccountBtn) {
        createAccountBtn.removeAttribute("href");
        createAccountBtn.addEventListener("click", (event) => {
            event.preventDefault();
            document.querySelector("#step-1").scrollIntoView();
            toggleSignupForm(true);
        });
    }

    signupCancel.addEventListener("click", (event) => {
        event.preventDefault();
        toggleSignupForm(false);
    });

    signupBtnBody?.addEventListener("click", (event) => {
        event.preventDefault();
        toggleSignupForm(true);
    });

    // Handle all "Sign Up" buttons
    const signupButtons = document.querySelectorAll(".signup-btn");
    signupButtons.forEach(btn => {
        btn.addEventListener("click", (event) => {
            event.preventDefault();
            const formId = btn.dataset.formId;
            const form = document.querySelector(`#${formId}`);
            const errorForm = document.querySelector(`#${formId} .error-form`);
            const successForm = document.querySelector(`#${formId} + .success-form`);
            const signupOverlay = document.querySelector(`#${formId} .signup-overlay`);
            const submitBtn = document.querySelector(`#${formId} #signup-btn`);
            const replaceMail = document.querySelector(`#${formId} + .success-form #replace-mail`);
            const formControls = form.querySelectorAll(".form-control");

            signupOverlay.style.display = "block";

            if (!form.checkValidity()) {
                event.stopPropagation();
                submitBtn.style.display = "block";
                setTimeout(() => {
                    signupOverlay.style.display = "none";
                }, 500);
            } else {
                const data = new FormData(form);

                const signupData = {
                    accountInfo: {
                        isp: data.get("isp"),
                        firstName: data.get("firstName"),
                        lastName: data.get("lastName"),
                        companyName: data.get("companyName"),
                        emailAddress: data.get("emailAddress")
                    }, captcha: {
                        captchaInput: data.get("captchaInput"),
                        captchaText: data.get("captchaText"),
                        key: data.get("key")
                    }
                };

                fetch("/app/service/signup/create-account", {
                    method: "POST", body: JSON.stringify(signupData)
                })
                    .then(response => response.json())
                    .then(res => {
                        // If there's an error (res.status = true means an error in this context)
                        if (res.status) {
                            window.direct.fetchAndUpdateCaptcha();
                            errorForm.innerHTML = res.detail;
                            errorForm.style.display = "block";
                            formControls.forEach(control => {
                                control.addEventListener("input", () => {
                                    control.classList.remove("is-invalid");
                                    errorForm.style.display = "none";
                                });
                            });
                        } else {
                            // On success
                            form.reset();
                            form.style.display = "none";
                            successForm.style.display = "block";
                            replaceMail.innerHTML = replaceMail.innerHTML.replace(/aaaaa/g, res.emailAddress);
                        }

                        setTimeout(() => {
                            signupOverlay.style.display = "none";
                        }, 500);
                    });
            }

            form.classList.add("was-validated");
        });
    });

    // Refresh captcha
    const refreshCaptcha = document.querySelectorAll(".refresh-captcha");
    refreshCaptcha.forEach(btn => {
        btn.addEventListener("click", (event) => {
            event.preventDefault();
            window.direct.fetchAndUpdateCaptcha();
        });
    });

    // Fetch the first captcha on load
    window.direct.fetchAndUpdateCaptcha();
});
